import "./animation.scss";

function ProccessingSVG(props: any) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ animation: "spin infinite 0.7s steps(16)" }}
      {...props}
    >
      <path
        d="M48.0002 23.0401C50.1209 23.0401 51.8401 21.3209 51.8401 19.2001C51.8401 17.0793 50.1209 15.3601 48.0002 15.3601C45.8794 15.3601 44.1602 17.0793 44.1602 19.2001C44.1602 21.3209 45.8794 23.0401 48.0002 23.0401Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.3"
        d="M48.0002 80.64C50.1209 80.64 51.8401 78.9207 51.8401 76.8C51.8401 74.6792 50.1209 72.96 48.0002 72.96C45.8794 72.96 44.1602 74.6792 44.1602 76.8C44.1602 78.9207 45.8794 80.64 48.0002 80.64Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.3"
        d="M62.4005 26.8799C64.5213 26.8799 66.2405 25.1607 66.2405 23.04C66.2405 20.9192 64.5213 19.2 62.4005 19.2C60.2798 19.2 58.5605 20.9192 58.5605 23.04C58.5605 25.1607 60.2798 26.8799 62.4005 26.8799Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.3"
        d="M33.5998 76.8001C35.7205 76.8001 37.4398 75.0809 37.4398 72.9601C37.4398 70.8393 35.7205 69.1201 33.5998 69.1201C31.479 69.1201 29.7598 70.8393 29.7598 72.9601C29.7598 75.0809 31.479 76.8001 33.5998 76.8001Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.93"
        d="M33.5998 26.8799C35.7205 26.8799 37.4398 25.1607 37.4398 23.04C37.4398 20.9192 35.7205 19.2 33.5998 19.2C31.479 19.2 29.7598 20.9192 29.7598 23.04C29.7598 25.1607 31.479 26.8799 33.5998 26.8799Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.3"
        d="M62.4005 76.8001C64.5213 76.8001 66.2405 75.0809 66.2405 72.9601C66.2405 70.8393 64.5213 69.1201 62.4005 69.1201C60.2798 69.1201 58.5605 70.8393 58.5605 72.9601C58.5605 75.0809 60.2798 76.8001 62.4005 76.8001Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.65"
        d="M19.1994 51.8399C21.3201 51.8399 23.0394 50.1207 23.0394 47.9999C23.0394 45.8791 21.3201 44.1599 19.1994 44.1599C17.0786 44.1599 15.3594 45.8791 15.3594 47.9999C15.3594 50.1207 17.0786 51.8399 19.1994 51.8399Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.3"
        d="M76.8009 51.8399C78.9217 51.8399 80.6409 50.1207 80.6409 47.9999C80.6409 45.8791 78.9217 44.1599 76.8009 44.1599C74.6802 44.1599 72.9609 45.8791 72.9609 47.9999C72.9609 50.1207 74.6802 51.8399 76.8009 51.8399Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.86"
        d="M23.0392 37.44C25.16 37.44 26.8792 35.7208 26.8792 33.6C26.8792 31.4792 25.16 29.76 23.0392 29.76C20.9184 29.76 19.1992 31.4792 19.1992 33.6C19.1992 35.7208 20.9184 37.44 23.0392 37.44Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.3"
        d="M72.9591 66.2401C75.0799 66.2401 76.7991 64.5208 76.7991 62.4001C76.7991 60.2793 75.0799 58.5601 72.9591 58.5601C70.8384 58.5601 69.1191 60.2793 69.1191 62.4001C69.1191 64.5208 70.8384 66.2401 72.9591 66.2401Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.44"
        d="M23.0392 66.2401C25.16 66.2401 26.8792 64.5208 26.8792 62.4001C26.8792 60.2793 25.16 58.5601 23.0392 58.5601C20.9184 58.5601 19.1992 60.2793 19.1992 62.4001C19.1992 64.5208 20.9184 66.2401 23.0392 66.2401Z"
        fill="#BDBFBF"
      />
      <path
        opacity="0.3"
        d="M72.9591 37.44C75.0799 37.44 76.7991 35.7208 76.7991 33.6C76.7991 31.4792 75.0799 29.76 72.9591 29.76C70.8384 29.76 69.1191 31.4792 69.1191 33.6C69.1191 35.7208 70.8384 37.44 72.9591 37.44Z"
        fill="#BDBFBF"
      />
    </svg>
  );
}

export default ProccessingSVG;
